import { render, staticRenderFns } from "./AntiScamBotStatistic.vue?vue&type=template&id=54b42696"
import script from "./AntiScamBotStatistic.vue?vue&type=script&lang=js"
export * from "./AntiScamBotStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports